import { Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { DayPilot, DayPilotSchedulerComponent } from 'daypilot-pro-angular';
import * as moment from 'moment';
import { interval, Observable, Subscription } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { CreateServiceRequestDialog, RentalDialog, ServiceBookingDialog, ObjectDialog, FindBookingDialog } from '../../../../t4common';
import { BookingErrorCode, BookingValidation, OpenHours, RentalInfo, RentalObjectInfo, RentalStatus, TurboHubEventType, CustomerType, ApiService, PageBase } from 't4core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Type } from '@angular/core';
import { TheftDialog } from '../../dialogs/TheftDialog/TheftDialog';
import { OrderServiceDialog } from '../../dialogs/OrderServiceDialog/OrderServiceDialog';

@Component({
    selector: 'calendar',
    templateUrl: './calendar.html',
    styleUrls: [ './CalendarStyles.css']
})
export class Calendar extends PageBase implements OnInit, OnDestroy {
    @ViewChild("typeTooltip", {static: false})
    private typeTooltip: ElementRef;
    private locales = { sv: 'sv-se', da: 'da-dk', no: 'nb-no', en: 'en-us', is: 'en-us', de: 'de-de' };

    private updateInterval: Subscription;
  private timeInterval: Subscription;
  private updateCount: number = 0;

    public isLoadingEvents: boolean = false;
    public resourceHeaderWidth: number = 0;
    public html: string;
    public isDialogOpen: boolean = false;
    public showDeleted: boolean = false;
    public toggleDeleted() {
        this.showDeleted = !this.showDeleted;

        this.reload();
  }

  public async ngOnInit() {
        var token = this.UI.beginLoading("Turbo.Bookings.Calendar.msgLoadingCalendar", "Loading your calendar", null);

        await this.reload();

        this.scheduler.control.update({ separators: [{ color: "Red", location: new DayPilot.Date() }] });
        this.timeInterval = interval(60000).subscribe(() => {
            this.scheduler.control.update({ separators: [{ color: "Red", location: new DayPilot.Date() }]});
        });


    this.updateInterval = interval(60000).subscribe(async x => {
      if (this.updateCount > 120) return;
          this.reload();
          this.updateCount++;
          if (this.updateCount > 120)
            this.UI.alert("Turbo.Bookings.Calendar.headSleepMode", "T4 has entered sleep mode", "Turbo.Bookings.Calendar.msgSleepMode", "T4 has entered sleep mode in order to save energy. Click ok to continue!").then(x => {
              this.updateCount = 0;
              this.reload();
            });
          
        });
      
        // Load open hours
        var hours = await this.api.get<OpenHours[]>("Location/GetOpenHoursForPeriod", { locationId: this.Settings.clientSettings.RentalLocationId, startDate: new DayPilot.Date().addDays(-10), endDate: new DayPilot.Date().addDays(10) });
     
       for (var x of hours) this.openHours.push(x);
        
        this.scheduler.control.update();
      //this.reload();
        await new Promise(resolve => setTimeout(resolve, 500));
      // await this.gotoDate(this.now);
        this.UI.loaderCompleted(token);

        // Attach mouse listeners
        var resources = this.el.nativeElement.querySelectorAll('.scheduler_default_rowheader');
        for (var ii = 0; ii < resources.length; ii++) {
            resources[ii].addEventListener('mouseover', x => this.ResourceMouseOver(x));
            resources[ii].addEventListener('mouseout', x => this.ResourceMouseOut());
        }

      // TODO Implement signal R

      this.Notifications.onEvent.pipe(filter(x => x.Type == TurboHubEventType.Booking))
        .subscribe(x => {
          console.log("R: " + x.EntityId);
          this.LoadEvents({});
        });
    }

    public async ngOnDestroy() {
        this.timeInterval.unsubscribe();
        this.updateInterval.unsubscribe();
    }

    private objects: RentalObjectInfo[] = [];

    constructor(private api: ApiService, private el: ElementRef, private router: Router, private route: ActivatedRoute, private http: HttpClient) {
        super(el, "Bookings");
    }

    public zoom: number = 0;

    public updateZoom() {
        switch (this.zoom) {
            case 0: // day
                this.config.cellWidth = 15;
                this.config.cellDuration = 15;
                this.config.timeHeaders = [
                    {
                        "groupBy": "Day",
                        "format": "dddd, d MMMM yyyy"
                    },
                    {
                        "groupBy": "Hour"
                    }
                ];
                this.config.days = 6;
                this.config.infiniteScrollingStepDays = 2;
                break;

            case 1: // weekend
                this.config.cellWidth = 20;
                this.config.cellDuration = 60;
                this.config.timeHeaders = [
                    {
                        "groupBy": "Day",
                        "format": "dddd, d MMMM yyyy"
                    },
                    {
                        "groupBy": "Hour"
                    }
                ];
                this.config.days = 16;
                this.config.infiniteScrollingStepDays = 8;
                break;

            case 2: // Week
                this.config.cellWidth = 10;
                this.config.cellDuration = 60;
                this.config.timeHeaders = [
                    {
                        "groupBy": "Week",
                    },
                    {
                        "groupBy": "Day"
                    }
                ];
                this.config.days = 56;
                this.config.infiniteScrollingStepDays = 14;
                break;
        }

        this.reload();
        this.gotoDate(this.now);
    }

    @ViewChild('scheduler', {static: false})
    scheduler: DayPilotSchedulerComponent;
    openHours: OpenHours[] = [];

    config: any = {
        // Setup
        heightSpec: "Parent100Pct",

        locale: this.locales[this.Settings.clientSettings.Language],
        days: 6,
        startDate: DayPilot.Date.today().addDays(-2),

        timeHeaders: [
            {
                "groupBy": "Day",
                "format": "dddd, d MMMM yyyy"
            },
            {
                "groupBy": "Hour"
            }
        ],
        
        CssOnly:true,
        CSSClassPrefix: "turbo",
        scale: "CellDuration",
        cellDuration: 15,
        headerHeight: 20,
        showNonBusiness: true,
        businessBeginsHour: 0,
        businessEndsHour: 24,
        businessWeekends: true,
        cellWidthSpec: "Fixed",
        cellWidth: 15,
        rowHeaderWidth: 200,
        
        eventHeight: 40,
        floatingEvents: true,
       
        groupConcurrentEvents: false,
        eventStackingLineHeight: 100,
        
        eventHoverHandling: "Bubble",
        bubble: new DayPilot.Bubble({
            onLoad: function (args) {
                var ev = args.source;
                args.html = "<span style='color:black; font-weight: bold;'>" + ev.data.datasource.Id + "</span>";
                args.html += "<br/><span style='color:black;'>" + ev.data.datasource.PickupTime.format("D/M HH:mm") + " - " + ev.data.datasource.ReturnTime.format("D/M HH:mm") + "</span>";
                args.html += "<br /><span style='color:gray'>" + ev.data.datasource.Customer.Firstname + ' ' + ev.data.datasource.Customer.Lastname + "</span>";
                if (ev.data.datasource.Note) args.html += "<br /><span style='color:gray;font-style: italic;'>" + ev.data.datasource.Note + "</span>";
                args.loaded();
            }
        }),

        // Event events
        eventMovingStartEndEnabled: false,
        eventResizingStartEndEnabled: false,
        timeRangeSelectingStartEndEnabled: false,
        allowEventOverlap: false,

        timeRangeSelectedHandling: "Enabled",
        onTimeRangeSelecting: x => this.TimeSelecting(x),
        onTimeRangeSelected: (x) => this.NewEvent(moment(x.start.toString()), moment(x.end.toString()), this.Settings.clientSettings.RentalLocationId, this.Settings.clientSettings.RentalLocationId, x.resource, x),

        eventClickHandling: "Enabled",
        onEventClick: (x) => this.EventClicked(x),

        eventMoveHandling: "Notify",
        eventMoveSkipNonBusiness: true,
        onEventMoving: x => this.EventMoving(x),
        onEventMoved: x => this.UpdateBooking(x),

        eventResizeHandling: "Notify",
        onEventResizing: x => this.EventResizing(x),
        onEventResized: x => this.UpdateBooking(x),

        eventDeleteHandling: "Update",
        onEventDeleted: x => this.DeleteBooking(x),

        onResourceHeaderColumnResized: x => {
            this.resourceHeaderWidth = x.column.width;
        },

        // Resources
        allowDefaultContextMenu: true,
        treeEnabled: true,
        treePreventParentUsage: true,
        contextMenuResource: new DayPilot.Menu({
            items: [
                { text: this.translate('Turbo.Bookings.Calendar.mnuDetails', 'Show details...'), onClick: x => { ObjectDialog.open(this.Dialog, null, x.source.value); } },
                { text: this.translate('Turbo.Bookings.Calendar.mnuConfirmDelete', 'Confirm removal'), onClick: x => { this.confirmRemoval(x.source.value); } },
                { text: '-' },
                this.Settings.clientSettings.CanOrderService ?
                  { text: this.translate('Turbo.Bookings.Calendar.mnuOrderService', 'Order service'), onClick: x => { OrderServiceDialog.open(this.Dialog, x.source.value); } } :
                  null,
                { text: this.translate('Turbo.Bookings.Calendar.mnuDisable', 'Disable trailer...'), onClick: x => { CreateServiceRequestDialog.open(this.Dialog, x.source.value, this.Settings.clientSettings.RentalLocationId); } },
                {
                    text: this.translate('Turbo.Bookings.Calendar.mnuReenable', 'Re-enable'), onClick: async x => {
                        var ret = await this.UI.confirm("Turbo.FleetManager.Objects.headConfirmReenable", "Re-enable object", "Turbo.FleetManager.Objects.msgConfirmReenable", 'You are about to enable an object. Make sure that any active issues are resolved. And if so, close them so that they will not impact your performance negatively.');
                    if (ret) {

                         var hasIssues = await this.Api.get<boolean>("RentalObject/PreEnableCheck", { objectId: x.source.value });
                      if (hasIssues) {
                      var override = await this.Dialog.open(TheftDialog, {
                          maxWidth: "650px"
                      }).afterClosed().toPromise();
                      //If we are admin, we should be able to override, and enable it.
                        if (override == true) {
                          await this.Api.get<any>("RentalObject/Enable", { objectId: x.source.value });
                          this.updateResources();
                        }
                      } else {
                        await this.Api.get<any>("RentalObject/Enable", { objectId: x.source.value });
                        this.updateResources();
                      }
                        }
                    }
                },
                { text: '-' },
                { text: this.translate('Turbo.Bookings.Calendar.mnuShowDelayedBooking', 'Show delayed booking...'), onClick: x => { this.findDelayedBooking(x.source.value); } },
            { text: this.translate('Turbo.Bookings.Calendar.mnuLock', 'SmartLock info...'), onClick: x => { ObjectDialog.open(this.Dialog, null, x.source.value, 4); } },
            ].filter(item => item !== null),
            onShow: args => {
                this.UI.drop(this.typeTooltip.nativeElement);
                let e = args.source;
                args.menu.items[0].text = this.translate('Turbo.Bookings.Calendar.mnuDetails', 'Show details...');
              args.menu.items[1].text = this.translate('Turbo.Bookings.Calendar.mnuConfirmDelete', 'Confirm removal');
              if (this.Settings.clientSettings.CanOrderService) {
                args.menu.items[3].text = this.translate('Turbo.Bookings.Calendar.mnuOrderService', 'Order service');
                args.menu.items[4].text = this.translate('Turbo.Bookings.Calendar.mnuDisable', 'Disable trailer...');
                args.menu.items[5].text = this.translate('Turbo.Bookings.Calendar.mnuReenable', 'Re-enable');
                args.menu.items[7].text = this.translate('Turbo.Bookings.Calendar.mnuShowDelayedBooking', 'Show delayed booking...');
                args.menu.items[8].text = this.translate('Turbo.Bookings.Calendar.mnuLock', 'SmartLock info...');
                args.menu.items[1].disabled = !e.data.datasource.IsDeleted;
                args.menu.items[5].disabled = e.data.datasource.IsEnabled;
                args.menu.items[7].disabled = e.data.datasource.Status != 8;
                args.menu.items[8].hidden = (e.data.datasource.Locks == null);
              }
              else {
                args.menu.items[3].text = this.translate('Turbo.Bookings.Calendar.mnuDisable', 'Disable trailer...');
                args.menu.items[4].text = this.translate('Turbo.Bookings.Calendar.mnuReenable', 'Re-enable');
                args.menu.items[6].text = this.translate('Turbo.Bookings.Calendar.mnuShowDelayedBooking', 'Show delayed booking...');
                args.menu.items[7].text = this.translate('Turbo.Bookings.Calendar.mnuLock', 'SmartLock info...');
                args.menu.items[1].disabled = !e.data.datasource.IsDeleted;
                args.menu.items[4].disabled = e.data.datasource.IsEnabled;
                args.menu.items[6].disabled = e.data.datasource.Status != 8;
                args.menu.items[7].hidden = (e.data.datasource.Locks == null);
              }              
            }
        }),
      onAfterUpdate: x => {  // Attach mouse listeners
        var resources = this.el.nativeElement.querySelectorAll('.scheduler_default_rowheader');
        for (var ii = 0; ii < resources.length; ii++) {
          resources[ii].addEventListener('mouseover', x => this.ResourceMouseOver(x));
          resources[ii].addEventListener('mouseout', x => this.ResourceMouseOut());
        }
      },

        // Rendering
        onBeforeResHeaderRender: x => this.RenderResourceHeader(x),
        onBeforeRowHeaderRender: x => this.RenderRowHeader(x),
        onBeforeEventRender: x => this.RenderEvent(x),
        onBeforeCellRender: x => this.RenderCell(x),
        onIncludeTimeCell: x => this.IncludeCell(x),

        // Scrolling
        autoScroll: "Always",
        infiniteScrollingEnabled: true,
        infiniteScrollingStepDays: 2,
        infiniteScrollingMargin: 50,
        dynamicLoading: true,
        scrollDelayDynamic: 25,
      onScroll: x => {
        if (this.isInitialized) this.LoadEvents(x);
      },

        // Appearence
        crosshairType: "Full",
        crosshairColor: "red",
        crosshairOpacity: "10",

        //nonBusinessBackColor: "#fff",
        //backColor: "#eeeeff",

        resources: []
    };

    // Data
    private lastEventLoadMin: DayPilot.Date;
    private lastEventLoadMax: DayPilot.Date;
    private async LoadEvents(args: any) {
        let dp = this.scheduler.control;
        let viewport = dp.getViewPort();
        let from = viewport.start.addDays(-7);
        let to = viewport.end.addDays(7);

        if (this.lastEventLoadMin && viewport.start >= this.lastEventLoadMin && viewport.end <= this.lastEventLoadMax) {
            if (args.loaded) {
                args.events = this.scheduler.events;
                args.loaded();
            }
            //this.scheduler.control.update({ events: this.scheduler.events });
            return;
        }

        this.isLoadingEvents = true;
        this.lastEventLoadMin = from;
        this.lastEventLoadMax = to;

        //args.async = true;
        var ret: RentalInfo[] = [];
        if (this.showDeleted)
            ret = await this.api.get<RentalInfo[]>("Rental/GetDeletedRentals", { startTime: from, endTime: to });
        else
            ret = await this.api.get<RentalInfo[]>("Rental/GetRentals", { startTime: from, endTime: to });

            var newEvents = [];
            for (var i of ret) {
                newEvents.push(
                    {
                        "resource": i.ObjectId,
                        "id": i.Id,
                        "text": i.Id,
                        "start": new DayPilot.Date(i.PickupTime.toDate(), true),
                        "end": new DayPilot.Date(i.ReturnTime.toDate(), true),
                        "datasource": i,

                        moveHDisabled: i.Status > 50 && i.Status != 1,
                        resizeDisabled: i.Status > 50 && i.Status != 1 
                    }
                );
        }
        if (args.loaded) {
            args.events = newEvents;
            args.loaded();
        } else {
            this.scheduler.events = newEvents;
            this.scheduler.control.update();
        }
      
            

        // Update open hours
        var currentRangeStart = from.getDatePart().addDays(-1);
        var d = from.getDatePart().addDays(-1);
        while (d <= to.getDatePart().addDays(1)) {
            var h = this.openHours.find(x => x.Date.toDate().toDateString() == d.toDateLocal().toDateString())
            if (h) {
                if (currentRangeStart < d) {
                    this.api.get<OpenHours[]>("Location/GetOpenHoursForPeriod", { locationId: this.Settings.clientSettings.RentalLocationId, startDate: currentRangeStart, endDate: d.addDays(-1) }).then(ret => {
                        for (var x of ret) this.openHours.push(x);
                    });
                    this.scheduler.control.update();
                    break;
                }
                currentRangeStart = d.addDays(1);
            } else if (d.addDays(1) > to.getDatePart().addDays(1)) {
                this.api.get<OpenHours[]>("Location/GetOpenHoursForPeriod", { locationId: this.Settings.clientSettings.RentalLocationId, startDate: currentRangeStart, endDate: d }).then(ret => {
                    for (var x of ret) this.openHours.push(x);
                });
                this.scheduler.control.update();
                break;
            }

            d = d.addDays(1);
        }
        //args.loaded();
        this.isLoadingEvents = false;
    };

    private async updateResources() {
        var ret = await this.Api.get<RentalObjectInfo[]>("RentalObject/GetMyObjects");

        this.objects = [];
        this.config.resources = [];
        var categories = {};
        for (var i of ret.sort((a, b) => {
            if (a.CategoryIndex < b.CategoryIndex) return -1;
            if (a.CategoryIndex > b.CategoryIndex) return 1;
            if (a.IsEnabled < b.IsEnabled) return 1;    
            if (a.IsEnabled > b.IsEnabled) return -1;
            if (a.Alias < b.Alias) return -1;
            if (a.Alias > b.Alias) return 1;

            return 0;
        })) {
            this.objects.push(i);

            var category = 'Turbo.Data.ObjectCategory.Other';
            if (i.Category) category = i.Category;

            if (!categories[category])
                categories[category] = {
                    name: category.indexOf("Turbo.Data") == 0 ? this.translate(category) : category,
                    id: category,
                    expanded: true,
                  datasource: i,
                    children: [],
                    eventHeight: 25
                };

            var o: any = {
                name: i.Title,
                id: i.Id,
                datasource: i
            };

            if (!i.IsEnabled) o.eventHeight = 25;
            categories[category].children.push(o);
        }

        for (var cat in categories)
            this.config.resources.push(categories[cat]);
    }

  private isInitialized: boolean = false;
  private isUpdating: boolean = false;
  private async reload() {
    if (this.isUpdating || this.updateCount > 120 || this.isDialogOpen) return;

    this.isUpdating = true;

    await this.updateResources();
        this.lastEventLoadMin = null;
        this.lastEventLoadMax = null;
        if (this.scheduler && this.scheduler.control) {
            this.scheduler.control.events.list = [];
            this.scheduler.control.update();

          await this.LoadEvents({});
    }

    this.isInitialized = true;
    this.isUpdating = false;
    }
    public ResourceMouseOver(x: any) {
        for (var i = 0; i < x.currentTarget.classList.length; i++) {
            if (x.currentTarget.classList[i].indexOf("id_") == 0) {
                var target = x.srcElement;
                while (target != null && target.className != "scheduler_default_rowheader" && target.className.indexOf("scheduler_default_rowheader ") < 0 && target.className.indexOf(" scheduler_default_rowheader") < 0 && target.className.indexOf("scheduler_default_rowheader.") < 0) {
                    target = target.parentElement;
                }

                if (target == null) return;

                var width = target.clientWidth;
                var x1 = 0;
                var y1 = 0;

                do {
                    x1 += (target as any).offsetLeft;
                    y1 += (target as any).offsetTop;

                    target = target.parentElement;
                } while (target != null);

                this.currentTooltip = x.currentTarget.classList[i].substring(3);

                var scroll = this.el.nativeElement.querySelector(".scheduler_default_scrollable").scrollTop;
                this.UI.float(this.typeTooltip.nativeElement, x1 + width - 10, y1 - 40 - scroll);
                return;
            }
        }
    }
    public ResourceMouseOut() {
        this.UI.drop(this.typeTooltip.nativeElement);
    }

    // Rendering
    private RenderCell(args: any) {

        if (isNaN(args.cell.resource)) {
            args.cell.cssClass = 'category';
            return;
        }

        var resource = this.objects.find(x => x.Id == args.cell.resource);
        if (!resource) return;

        switch (resource.Status) {
            case 2:
                args.cell.cssClass = "activeResource";
                break;
            case 4:
                args.cell.cssClass = "maintenanceResource";
                break;

            case 8:
                args.cell.cssClass = "lateResource";
                break;
            default:
                args.cell.cssClass = "normalResource";
                break;
        }

        if (!resource.IsEnabled) {
            args.cell.cssClass += " disabledResource";
            args.cell.disabled = true;
        }

        var fromDate = moment(new Date(args.cell.start.value + "Z"));
        var toDate = moment(new Date(args.cell.end.value + "Z"));
        if (this.openHours) {
            var h = this.openHours.find(x => x.Date.format("YYYY-MM-DD") == fromDate.utc().format("YYYY-MM-DD"));
          if (h) {
                if (h.IsClosed) args.cell.business = false;
                if (h.Opens .isAfter(fromDate)) args.cell.business = false;
                if (h.Closes.isBefore(toDate)) args.cell.business = false;
            }
        }

        //if (resource.) {
        //    args.cell.cssClass += " deletedResource";
        //}
    }
    private IncludeCell(args: any) {
        var fromDate = moment(new Date(args.cell.start.value + "Z"));
        var toDate = moment(new Date(args.cell.end.value + "Z"));
        if (this.openHours && this.openHours.length > 0) {
            var h = this.openHours.find(x => x.Date.format("YYYY-MM-DD") == fromDate.utc().format("YYYY-MM-DD"));
            if (h) {
                if (h.Opens.clone().add(-2, 'hours').isAfter(fromDate)) args.cell.visible = false;
                else if (h.Closes.clone().add(2, 'hours').isBefore(toDate)) args.cell.visible = false;
                else args.cell.visible = true;
            }
        } else {
            args.cell.visible = true;
        }
    }

    public RenderEvent(args: any) {
        var event: RentalInfo = null;
        if (args.data instanceof RentalInfo) event = args.data;
        else event = args.data.datasource;

        var start = new DayPilot.Date(event.PickupTime.toDate());
        var end = new DayPilot.Date(event.ReturnTime.toDate());

        var today = DayPilot.Date.today();
        var now = new DayPilot.Date();

        args.e.barColor = "#68808a";
        switch (event.Status) {
            case 0:
               
                break;
            case -2:
                args.e.barColor = "#000";  // red
                args.e.toolTip = 'Service';
                args.data.cssClass = "serviceEvent";

                break;

            case 1:
                args.e.barColor = "#e52a16";  // red
                args.e.toolTip = 'Late';
                args.data.cssClass = "lateEvent";

                break;

            case 100:
                    args.e.barColor = "#eabc31";  // red
                args.e.toolTip = 'Active';
                args.data.cssClass = "activeEvent";
                
                break;
            case 150:
                args.e.barColor = "#e52a16";  // red
                args.e.toolTip = 'Late';
                args.data.cssClass = "lateEvent";

                break;
            case 200:
                args.e.barColor = "#1e9b38";  // red
                args.e.toolTip = 'Returned';
                args.data.cssClass = "returnedEvent";

                break;
            default:
                args.e.toolTip = "Unexpected state";
                break;
        }
        args.e.html = "<span style='color:black; font-weight: bold;'>" + (event.Status == RentalStatus.Service ? '' : args.e.text) + "</span>";
        if (event.Customer!.Type == CustomerType.Consumer)
            args.e.html = args.e.html + "<br /><span class='eventText'>" + event.Customer!.Firstname + ' ' + event.Customer!.Lastname + "</span>";
        if (event.Customer!.Type == CustomerType.Company)
            args.e.html = args.e.html + "<br /><span class='eventText'>" + event.Customer!.CompanyName + ' (' + event.Customer!.Firstname + ")</span>";
        if (event.Note) args.e.html = args.e.html + "<br /><span class='eventText' style='font-style: italic;max-width: calc(100% - 50px); overflow: hidden; display: inline-block; text-overflow: ellipsis;'>" + event.Note + "</span>";

        //var paid = event.Price.DiscountedTotalPrice;

        args.e.areas = [];
        //if (event.Status != RentalStatus.Service) {
        //    args.e.areas.push({ top: 5, right: 5, html: "<div class='eventText' style='font-size: 8pt;'>" + paid + "kr</div>", v: "Visible" });
        //}

        if (event.IsWebRental) {
            args.e.areas.push({ bottom: 5, right: 5, html: "<img src='/images/icons/32/web.png' style='width: 16px;'/>", v: "Visible" });
        }

    };
    public RenderResourceHeader(args: any) {
        if (args.resource.children) {
            args.resource.cssClass = "category";
            return;
        }
        
        args.resource.html = "<div class='resourceName'>" + args.resource.datasource.Title + "</div>";
        if (args.resource.datasource.Alias) args.resource.html += "<div class='resourceAlias' title='" + args.resource.datasource.Alias  + "'>" + args.resource.datasource.Alias + "</div>";
        //if (args.resource.datasource.Type) args.resource.html += "<div class='resourceType'>" + args.resource.datasource.Type.Alias + "</div>";
        
        //args.resource.columns[1].html = "";

        switch (args.resource.datasource.Status) {
            case 2:
                args.resource.cssClass = "activeResource";
                break;
            case 4:
                args.resource.cssClass = "maintenanceResource";
                break;

            case 8:
                args.resource.cssClass = "lateResource";
                break;
            default:
                args.resource.cssClass = "normalResource";
                break;
        }

        if (!args.resource.datasource.IsEnabled) {
            args.resource.cssClass += " disabledResource";
            args.resource.html = "<div class='resourceName'>" + args.resource.datasource.Title + "</div>";
        }

        if (args.resource.datasource.IsDeleted) {
            args.resource.cssClass += " deletedResource";
        }

        args.resource.cssClass += " id_" + args.resource.datasource.Id;



        args.areas = [{
            width: 17,
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            visibility: "Hover",
            cssClass: "resource_action_menu",
            html: "<div><div></div></div>",
            javascript: "alert(e.Value);"
        }, {
                width: 17,
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
                visibility: "Visible",
                cssClass: "",
                html: "<img src=\"" + args.resource.datasource.Image + "\" />",
            }];
    }

    public RenderRowHeader(args: any) {
        if (isNaN(args.row.data.id)) return;

        args.row.areas = [{
                width: 50,
                left: 0,
                bottom: 0,
                visibility: "Visible",
                cssClass: "",
                html: "<div class=\"image\"><img src=\"" + args.row.data.datasource.Image + "\" /></div>",
            }];

        var content = "";
        if (!args.row.data.datasource.IsEnabled) {
            content += "<img src='/images/icons/32/Disabled.png' style='width: 16px;'/>";
        }
        if (args.row.data.datasource.IsDeleted) {
            content += "<img src='/images/icons/32/Delete.png' style='width: 16px;'/>";
        }
        if (args.row.data.datasource.HasIssues || args.row.data.datasource.HasNotes) {
            content += "<img src='/images/icons/32/Warning.png' style='width: 16px;'/>";
        }

        if (content != "") {
            args.row.areas.push({ top: 2, right: 16, html: content , v: "Visible" });
        }
    }

    public currentTooltip: number = 0;
    public typeTooltip_MouseOut() {
        this.UI.drop(this.typeTooltip.nativeElement);
    }

    // Drag'n drop
    private TimeSelecting(args: any) {
        if (args.start < new DayPilot.Date().addMinutes(-15) || this.showDeleted) {
            args.left.enabled = false;
            args.left.html = "";
            args.right.enabled = false;
            args.allowed = false;
        } else {
            args.left.enabled = true;
            args.right.enabled = true;
            args.left.html = args.start.toString("HH:mm");
            args.right.html = args.end.toString("HH:mm");
        }        
    }

    private EventMoving(args: any) {
        if (args.start < new DayPilot.Date().addMinutes(-15)  || this.showDeleted) {
            args.left.enabled = false;
            args.left.html = "";
            args.right.enabled = false;
            args.allowed = false;
        } else {
            args.left.enabled = true;
            args.left.html = args.start.toString("HH:mm");
        }
    }

    private EventResizing(args: any) {
        if ((args.start != args.e.start() && args.start < new DayPilot.Date().addMinutes(-15)) || this.showDeleted) {
            args.left.enabled = false;
            args.left.html = "You can't drag the event out of the visible range";
            args.right.enabled = false;
            args.allowed = false;
        }
    }

    // Events
    private async UpdateBooking(booking: any) {
        if (this.showDeleted) return;

        var x = await this.UI.confirm("Turbo.Bookings.Calendar.headConfirmChange", "Save changes?", "Turbo.Bookings.Calendar.msgConfirmChange", "Do you want to save the changes made to booking with id {0}?", null, [booking.e.id()]);
        if (x) {
            var result = await this.Api.put<BookingValidation>("/Rental/UpdateBooking", null,
                {
                    rentalId: booking.e.id(),
                    pickupTime: booking.newStart.toString() + "L",
                    returnTime: booking.newEnd.toString() + "L",
                    pickupLocation: booking.e.data.datasource.PickupLocationId,
                    returnLocation: booking.e.data.datasource.PickupLocationId,
                    obj: (booking.newResource ? booking.newResource : booking.e.resource()),
                    typeId: null
                });

            if (result.AggregatedResult != BookingErrorCode.Valid && result.AggregatedResult != BookingErrorCode.PickupReceiptUpdated) {
                this.reload();
                await this.UI.alert("Turbo.Bookings.Calendar.headChangeFailed", "Could not save the changes", "Turbo.Bookings.Calendar.msgChangeFailed", "Server returned an error.");
            } else {
                if (result.AggregatedResult == BookingErrorCode.PickupReceiptUpdated)
                    await this.UI.alert("Turbo.Bookings.Calendar.headReceiptUpdated", "Pickup receipt has been updated", "Turbo.Bookings.Calendar.msgReceiptUpdated", "Open the booking and reprint the receipt.");

                this.reload();
                this.Insights.logEvent("UpdateBooking");
            }
        }
    }

    private async DeleteBooking(booking: any) {
        if (this.showDeleted) return;

        var x = await this.UI.confirm("Turbo.Core.RentalDialog.headConfirmCancel", "Are you safe?", "Turbo.Core.RentalDialog.msgConfirmCancel", 'Are you secure that you want to cancel this booking?');
        if (x) {
            var result = await this.Api.delete<BookingErrorCode>("/Rental/Cancel",
                {
                    booking: booking.e.id()
                });

            if (result == BookingErrorCode.Valid) {
                this.Insights.logEvent("CancelBooking");
                this.reload();
            } else {
                booking.preventDefault();
                alert("Failed! " + result);
            }
        }
    }

    private async EventClicked(args: any) {
        if (args.e.data.datasource.Status == -2) {
            this.DeleteBooking(args);
        } else {
            this.isDialogOpen = true;
            await RentalDialog.openBooking(this.Dialog, args.e.data.datasource.Id);
            this.isDialogOpen = false;
            this.reload();
        }
    }


    public async addBooking() {
        var start = moment();
        var end = start.clone().add(this.Settings.clientSettings.Bookings.DefaultBookingLength, 'hour');
        var obj: number = 0;

        var i = 0;
        var ret: BookingValidation; 
        do {
            if (i < this.objects.length) obj = this.objects[i].Id
            else break;

            ret = await this.Api.post<BookingValidation>("/Rental/ValidateBooking", null,
                {
                    rentalId: null,
                    pickupTime: start.toISOString(),
                    returnTime: end.toISOString(),
                    pickupLocation: this.Settings.clientSettings.RentalLocationId,
                    returnLocation: this.Settings.clientSettings.RentalLocationId,
                    isOneWay: false,
                    objectId: obj
                });
            i++;
        }
        while (ret.ErrorCode == BookingErrorCode.ObjectUnavailable);

        this.NewEvent(start, end, this.Settings.clientSettings.RentalLocationId, this.Settings.clientSettings.RentalLocationId, obj, null);

    }

    private async NewEvent(pickupTime: moment.Moment, returnTime: moment.Moment, pickupLocation: number, returnLocation: number, objectId: number, x: any) {
        if (this.showDeleted) return;
        this.scheduler.control.clearSelection();

        let i = await RentalDialog.newBooking(this.Dialog, {
                pickupTime: pickupTime,
                returnTime: returnTime,
                pickupLocationId: pickupLocation,
                returnLocationId: returnLocation,
                objectId: objectId,
                typeId: this.objects.find(x => x.Id == objectId).Type.Id
            }, this.Settings);

                this.reload();
    }

    public async newServiceBooking() {
        var dlg = this.Dialog.open(ServiceBookingDialog, {
            maxHeight: "calc(100vh - 100px)",
            data: {}
        });

        await dlg.afterClosed().toPromise();
        this.reload();
    }

    public async confirmRemoval(objectId: number) {
        var x = await this.UI.confirm("Turbo.Bookings.Calendar.headConfirmDelete", "Confirm removal", "Turbo.Bookings.Calendar.msgConfirmDelete", "Do you want to confirm the removal of this object?", null, null);
        if (x) {
            await this.Api.post<boolean>("RentalObject/DeleteObject", null, { objectId: objectId });
            this.reload();
        }
    }

    // Commands
    public async gotoDate(date: moment.Moment = null) {
        if (!date) {
            date = await this.UI.selectDate();
        }

        var x = date.clone().toDate();
        var y = moment(this.scheduler.control.startDate.toString()).toDate().valueOf();
        if (Math.abs((y - x.valueOf()) / 1000 / 60 / 60 / 24) < 3)
            this.scheduler.control.scrollTo(new DayPilot.Date(x));
        else {
            this.scheduler.control.startDate = new DayPilot.Date(x);
            this.scheduler.control.update();
            this.scheduler.control.scrollTo(new DayPilot.Date(x));
      }

      await this.reload();
    }

    private async findDelayedBooking(objectId: number) {
        var rentalId = await this.Api.get<number>("Rental/FindDelayedBooking", { objectId: objectId });
        if (rentalId > 0) {
            await RentalDialog.openBooking(this.Dialog, rentalId);
            this.reload();
        } else {
            await this.UI.alert("Turbo.Bookings.Calendar.headNoDelayedBooking", "Unexpected error", "Turbo.Bookings.Calendar.msgNoDelayedBooking", "No delayed booking was found");
        }
    }

    public findBooking() {
        var dlg = this.Dialog.open(FindBookingDialog, {});
    }

    public async createPriceList() {
        var URL = "https://t4api.brenderuprental.com/Documents/Tools/DownloadPriceList?locationId=" + this.Settings.clientSettings.RentalLocationId;

        window.open(URL, "_blank");
    }

    // Helpers
    private updateKpi() {
        //this.api.get<LocationKpi>("Rental/GetTurnover", { startTime: moment().startOf('month').toISOString(), endTime: moment().startOf('month').add(1, 'month').toISOString() }).then(x => {
        //    var a = '###', b = '###', c = '###';
        //    if (x.Turnover) a = x.Turnover.toString();
        //    if (x.Prognosis) b = x.Prognosis.toString();
        //    if (x.Rentals) c = x.Rentals.toString();

        //    this.config.cornerHtml = "<div style='font-weight: bold;padding: 0 5px;'><span style='width: 75px; display: inline-block;'>Turnover: </span><span style='float: right;'>" + a + "kr</span></div>";
        //    this.config.cornerHtml += "<div style='font-style: italic;padding: 0 5px;'><span style='width: 75px; display: inline-block;'>Prognosis: </span><span style='float: right;'>" + b + "kr</span></div>";
        //    this.config.cornerHtml += "<div style='margin-top: 10px;padding: 0 5px;><span style='width: 75px; display: inline-block;'>Rentals: </span><span style='float: right;'>" + c + " st</span></div>";

        //    if (this.Settings.clientSettings.Version < TurboVersion.Professional) {
        //        this.config.cornerHtml += "<div style='position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255,255,255,0.75)'><div style='text-align: center; position: absolute; top: 50%; transform: translateY(-50%);width: 100%;'>Pro version is required</div></div>";
        //    }

        //    this.scheduler.control.update();
        //});
    }
}

